// DRYLL Pfand Sync — keeps Pfand-Anpassung lines in sync with yearly cart lines.
//
// Frontend safety-net: when the customer removes (or qty-changes) the parent
// Elektrolyt-Drinks Jahresabo line, the locked Pfand-Anpassung line is updated
// or removed to match. Without this, deleting the drink would leave a €33
// orphan Pfand line in the cart.
//
// The actual addition of Pfand-Anpassung happens in the PDP form-submit
// handler (dryll-pdp-cans.liquid). This script only handles the cleanup case.

(function () {
  if (window.__DRYLL_PFAND_SYNC__) return;
  window.__DRYLL_PFAND_SYNC__ = true;

  // Pfand-Anpassung Jahresabo (product 16214802530653) — variants per Dosen-tier
  var PFAND_PRODUCT_ID = 16214802530653;
  var TIER_TO_VARIANT = {
    12: 64766331224413,
    24: 64766331257181,
    36: 64766331289949,
    48: 64766331322717
  };

  var syncing = false;

  function extractTier(title) {
    if (!title) return null;
    var m = String(title).match(/(\d+)\s*Dosen/i);
    return m ? parseInt(m[1], 10) : null;
  }

  function isYearlyPlan(plan) {
    if (!plan || !plan.name) return false;
    return /j(ä|ae)hrlich|yearly|annual/i.test(plan.name);
  }

  function syncPfand() {
    if (syncing) return;
    syncing = true;

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pfandLines = [];
        var yearlyLines = [];

        cart.items.forEach(function (item) {
          if (item.product_id === PFAND_PRODUCT_ID) {
            pfandLines.push(item);
            return;
          }
          var alloc = item.selling_plan_allocation;
          if (alloc && isYearlyPlan(alloc.selling_plan)) {
            yearlyLines.push(item);
          }
        });

        // Nothing to do
        if (pfandLines.length === 0) {
          return null;
        }

        // Expected pfand quantity per variant (12/24/36/48)
        var expected = {};
        yearlyLines.forEach(function (line) {
          var tier = extractTier(line.variant_title || line.title || '');
          if (!tier) return;
          var variantId = TIER_TO_VARIANT[tier];
          if (!variantId) return;
          expected[variantId] = (expected[variantId] || 0) + line.quantity;
        });

        var updates = {};
        var needUpdate = false;

        pfandLines.forEach(function (line) {
          var want = expected[line.variant_id] || 0;
          if (want !== line.quantity) {
            updates[line.key] = want;
            needUpdate = true;
          }
        });

        if (!needUpdate) return null;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          // Refresh theme cart UI without re-firing cart:updated (avoid loop)
          if (window.theme && window.theme.cart && typeof window.theme.cart.buildCart === 'function') {
            try { window.theme.cart.buildCart(); } catch (e) { /* noop */ }
          }
          // On the standalone /cart page the snippet markup is server-rendered,
          // so we reload to reflect the corrected quantities.
          var path = window.location.pathname || '';
          if (path === '/cart' || /\/cart\/?$/.test(path)) {
            window.location.reload();
          }
        });
      })
      .catch(function (e) {
        if (window.console) console.error('[DRYLL Pfand sync]', e);
      })
      .then(function () {
        syncing = false;
      });
  }

  // Run when the theme tells us the cart changed.
  document.addEventListener('cart:updated', function () {
    // Defer so theme has time to finish its own cart refresh first.
    setTimeout(syncPfand, 80);
  });

  // Also run on first paint in case the user arrived via direct nav to /cart.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPfand);
  } else {
    syncPfand();
  }
})();
